
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class AdminEditDeleteLinks extends Vue {
  @Prop(String) table?: string;
  @Prop(Number) id?: number;
}
